import React, { Component } from 'react';
import ProjectPage from '../../components/ProjectPage';
import Table from '../../components/Table';

class ISS extends Component {
  render() {
    return (
    <ProjectPage title="ISS Web documentary">
      
      <div className='project-page-part'>

        <Table className="centered" data={{
          Status : "Finished",
          Type : "School project",
          Engine : "Unity",
          Language : "C#",
          Duration : "1 week",
          Team : "Group of 4",
          Date : "2021"
        }}/>

      </div>

      <div className='project-page-part'>

        <h3>Context :</h3>

        <p className='basic-text'>
          As part of the 2nd year of the DUT I had to create a web documentary with 3 friends. <br/>
          We did a web documentary about the ISS in the form of a point & click game.
        </p>

      </div>

      <div className='project-page-part'>

        <h3>Game :</h3>

        <p className='basic-text'>
          ISS Webdoc is a point & click game where you have to find objects used by astronauts through the different modules of the ISS.<br/>
          During your journey you will learn about the ISS and the life of astronauts inside the station.
        </p>

      </div>

      <div className='project-page-part'>

        <h3>My contribution :</h3>

        <p className='basic-text'>
          Development of the game
        </p>

      </div>

    </ProjectPage>
    );
  }
}

export default ISS;